export default "assets/images/logo-full-2ea36411.svg";